import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("activePage", location.pathname);
  }, [location]);

  return null;
};

export default RouteTracker;